"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var HistoryIcon_1 = __importDefault(require("../widgets/HistoryIcon"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        rootDiv: {
            display: 'block',
            textAlign: 'right',
            marginBottom: theme.spacing(3.5),
        },
        linkButton: {
            padding: 0,
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    });
});
function LinkHistoryButton(_a) {
    var clickHandler = _a.clickHandler;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    var theme = core_1.useTheme();
    return (react_1.default.createElement("div", { className: classes.rootDiv },
        react_1.default.createElement(core_1.Button, { className: classes.linkButton, onClick: clickHandler, size: "large", variant: "text" },
            react_1.default.createElement(core_1.Typography, { variant: "body2", color: "primary" }, t('editLink.viewLinkHistory')),
            react_1.default.createElement(HistoryIcon_1.default, { color: theme.palette.primary.main }))));
}
exports.default = LinkHistoryButton;
